import React, { useState, useEffect, useContext } from 'react';
import moment from 'moment';
import { Bar } from 'react-chartjs-2';
import { getDepositsWithdrawals } from '../../../constants/bank-statement-api';
import { LeadData } from '../../UploadedBankStatements/ManullyAddBankStaatements/ManuallyAddBankStatement';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faLessThan, faGreaterThan } from '@fortawesome/pro-light-svg-icons';
import { chartContainer } from '../BalanceOverview/BalanceOverview.module.css';

export default function AvgBalanceChart() {
  const leadDetails = useContext(LeadData);
  const [apiData, setApiData] = useState({});
  const [deposits, setDeposits] = useState({});
  const [withdrawals, setWithdrawals] = useState({});
  const [date, setDate] = useState({});
  const [minIndex, setMinIndex] = useState(0);

  useEffect(() => {
    getDepositsWithdrawals({
      leadId: leadDetails?.leadId,
      applicantId: leadDetails?.applicantId,
      docId: leadDetails?.docId
    }).then(res => {
      if (typeof res === 'object') {
        try {
          let data = JSON.parse(res?.data?.monthly_deposits_withdrawl);
          setApiData(data[`('amount', 'sum')`]);
        } catch (error) {
          console.error(error);
        }
      }
    });
  }, []);

  useEffect(() => {
    if (Object.values(apiData).length > 0) {
      addData();
    }
  }, [apiData, minIndex]);

  const addData = () => {
    const date = [];
    const depositeBalance = [];
    const withdrawalBalance = [];
    if (Object.keys(apiData).length > 0) {
      Object.keys(apiData).map((result, index) => {
        if (index >= minIndex && index < minIndex + 7) {
          let res = result?.replace(/[(|)]/g, function() {
            return '';
          });
          let arr = res.split(',');
          let y = arr[0];
          let m = arr[1];
          let flag = arr[2].substr(1);
          date.push(`
            ${moment(m, 'MM').format('MMM')}${' '}${parseInt(y)}`);
          let check = flag.toLowerCase();
          if (check === 'true') {
            if (
              !depositeBalance.includes(`${apiData[`(${y},${m}, ${flag})`]}`)
            ) {
              depositeBalance.push(apiData[`(${y},${m}, ${flag})`]);
            }
            let newFlag = !check + '';
            if (
              !apiData[
                `(${y},${m}, ${newFlag[0].toUpperCase() + newFlag.substr(1)})`
              ]
            ) {
              withdrawalBalance.push(0);
            }
          } else {
            if (!withdrawalBalance[`${apiData[`(${y},${m}, ${flag})`]}`]) {
              withdrawalBalance.push(apiData[`(${y},${m}, ${flag})`]);
            }
            let newFlag = !check + '';
            if (
              !apiData[
                `(${y},${m}, ${newFlag[0].toUpperCase() + newFlag.substr(1)})`
              ]
            ) {
              depositeBalance.push(0);
            }
          }
        }
      });
    }
    let newDate = [];
    date.map(res => {
      if (!newDate.includes(res.substr(13))) {
        newDate.push(res.substr(13));
      }
    });
    setDate({ date: newDate });
    setDeposits({ balance: depositeBalance });
    setWithdrawals({ balance: withdrawalBalance });
  };

  const handleLeft = () => {
    if (minIndex > 6) {
      const index = minIndex - 7;
      setMinIndex(index);
    }
  };

  const handleRight = () => {
    if (minIndex < Object.keys(apiData).length - 6) {
      const index = minIndex + 7;
      setMinIndex(index);
    }
  };

  return (
    <div className="w-full">
      <div className="w-full mt-5 bg-white pt-3 px-3 rounded">
        <p className="text-lg text-black-500 mb-3 font-bold">
          Deposits & Withdrawals
        </p>
        <hr className="w-full" style={{ borderColor: '#dee0f0' }} />
        <div className={`relative mt-1 ${chartContainer}`}>
          <div
            className="absolute flex flex-row items-center space-x-2 mr-3"
            style={{ right: '3px' }}
          >
            <div
              className="w-7 h-7 border border-black-50 rounded-full flex items-center justify-center cursor-pointer active:bg-black-50"
              style={{ boxShadow: '0 0 1px 1px #dfcbcb' }}
              onClick={handleLeft}
            >
              <FontAwesomeIcon icon={faLessThan} />
            </div>
            <div
              className="w-7 h-7 border border-black-50 rounded-full flex items-center justify-center cursor-pointer active:bg-black-50"
              style={{ boxShadow: '0 0 1px 1px #dfcbcb' }}
              onClick={handleRight}
            >
              <FontAwesomeIcon icon={faGreaterThan} />
            </div>
          </div>
          <Bar
            data={{
              labels: date['date'],
              datasets: [
                {
                  label: 'Withdrawals',
                  data: withdrawals['balance'],
                  backgroundColor: 'Black'
                },
                {
                  label: 'Deposits',
                  data: deposits['balance'],
                  backgroundColor: 'Yellow'
                }
              ]
            }}
            options={{
              scales: {
                xAxes: [
                  {
                    barPercentage: 0.4
                  }
                ]
              }
            }}
          />
        </div>
      </div>
    </div>
  );
}
